import { useContext, useMemo, useCallback } from "react";
import UserContext from "contexts/user.context";
import RolePermissions from "enums/role-permissions";

const usePermission = () => {
  const { user } = useContext(UserContext) ?? {};

  const granted = useMemo(() => {
    const set = new Set();
    (user?.groups ?? []).forEach((group) => {
      (RolePermissions[group] ?? []).forEach((perm) => set.add(perm));
    });
    return set;
  }, [user]);

  const can = useCallback((permission) => granted.has(permission), [granted]);

  const canAny = useCallback(
    (permissions = []) => permissions.some((p) => granted.has(p)),
    [granted]
  );

  return { can, canAny, user };
};

export default usePermission;
